import * as angular from "angular";

let EventUserCardComponent = {
    selector: "vcEventUserCard",
    templateUrl: "/angular/components/event/event-user-card.component.html",
    bindings: {
        data: "=",
        title: "=",
        attending: "=",
        message: "=",
        licenses: "=",
    },
    controller: class EventUserCardController {
        // * bindings for typescript compiler *
        public data: any;
        public title: any;
        public attending: any;
        public message: any;
        public licenses: any;
        // ************************************

        public limit = 10000000;

        $onInit() {
            this.data = this.data ? this.data : { count: 0, users: [] };
            if (this.message == "invited") {
                this.limit = 3;
            }
        }
    },
};

angular
    .module("event")
    .component(EventUserCardComponent.selector, EventUserCardComponent);
